import ScriptGroupParamVO from 'commons/vo/param/WkblScriptParamVO';
import ScriptParamVO, { ScriptPutParamVOProps } from 'commons/vo/param/ScriptParamVO';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  requestPutScript,
  requestScriptList,
  requestScriptListByScroll,
  selectScript,
} from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';
import ScriptVO from 'commons/vo/Script';

export default function useScript() {
  const dispatch = useDispatch();

  const onRequestScriptList = useCallback(
    (param: ScriptParamVO) => {
      dispatch(requestScriptList({ param }));
    },
    [dispatch],
  );

  const onRequestScriptListByScroll = useCallback(
    (param: ScriptParamVO) => {
      dispatch(requestScriptListByScroll({ param }));
    },
    [dispatch],
  );

  const onSelectScript = useCallback(
    (script: ScriptVO) => {
      dispatch(selectScript({ script }));
    },
    [dispatch],
  );

  const onRequestPutScript = useCallback(
    (param: ScriptPutParamVOProps) => {
      dispatch(requestPutScript({ param }));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      onRequestScriptList,
      onRequestScriptListByScroll,
      onSelectScript,
      onRequestPutScript,
    }),
    [onRequestScriptList, onRequestScriptListByScroll, onSelectScript, onRequestPutScript],
  );
}
